module.exports = __webpack_public_path__ + "img/ebook-shopping-mall-bg.0f8bddcf.jpg";